import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { allService } from '../services';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { deleteuser, logOut, removeToken } from '../actions';
import $ from 'jquery';

export default function Terms() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const [lang, setLang] = useState('Fr');
  const [downloadPopup, showDownloadPopup] = useState(false);

  const user = useSelector((state) => state.user);
  const isAuthenticated = useSelector((state) => state.connection);

  const changeLanguageHandler = (l) => {
    i18n.changeLanguage(l.toLowerCase());
    setLang(l);
  };

  const navigation = (nav) => {
    history.push({
      pathname: nav,
    });
  };

  const disconnect = () => {
    dispatch(logOut());
    dispatch(removeToken());
    dispatch(deleteuser());
    history.push('/login');
  };

  useEffect(() => {
    if (downloadPopup) {
      $('.modal-download').fadeIn('fast');
    } else {
      $('.modal-download').fadeOut('fast');
    }
  }, [downloadPopup]);

  return (
    <>
      <div
        className="w-100"
        style={{ height: 'auto', position: 'fixed', zIndex: 2000 }}
      >
        <div
          className="text-center elipsis pl-2 pr-2"
          style={{ background: '#C69E44', color: '#fff' }}
        >
          <span className="ads-txt">
            <span>
              <strong>No 1</strong>
            </span>
            <span className="font-weight-light">
              &nbsp;{t('Number_refill')}
            </span>
          </span>
        </div>

        <div
          style={{
            height: '70px',
            background: '#000a2b',
            color: '#fff',
            padding: '0 20px',
          }}
        >
          <div className="fl-l logo" style={{ position: 'relative' }}>
            <img className="img-fluid" src="/assets/img/glo-pay.png" />
          </div>

          <div
            className="fl-r cursor"
            style={{
              display: 'inline-block',
              verticalAlign: 'bottom',
              fontSize: '0.795em',
              position: 'relative',
              top: '16px',
            }}
          >
            <a
              data-toggle="dropdown"
              className="btn btn-primary option rounded-circle"
              role="button"
              href="#"
              style={{
                display: 'inline-block',
                padding: '1px 5px',
                paddingTop: '5px',
                fontSize: '0.985em',
                boxShadow: 'none',
                position: 'relative',
              }}
            >
              <i className="material-icons">person</i>
            </a>

            <div
              className="d-none d-md-inline-block text-left"
              style={{
                marginLeft: '6px',
                paddingRight: '10px',
                verticalAlign: 'top',
                position: 'relative',
                top: '-2px',
              }}
              data-toggle="dropdown"
            >
              {!allService.empty(user) && !allService.empty(user.name) && (
                <div>
                  <h6
                    className="fw-400 mb-0 d-inline-block mr-2"
                    style={{ fontSize: '0.965em' }}
                  >
                    {user.name.split(' ')[0]}&nbsp;
                    <strong>
                      {user.name.split('').length > 1
                        ? user.name.split(' ')[1]
                        : ''}
                    </strong>
                  </h6>
                  <i
                    className="icon-arrow-down cursor"
                    style={{ fontSize: '0.835em', position: 'relative' }}
                  ></i>
                  <span
                    className="d-block pr"
                    style={{ fontSize: '0.765em', top: '-7px' }}
                  >
                    {allService.chunk(user.telephone, 3, ' ')}
                  </span>
                </div>
              )}
            </div>

            <div
              className="dropdown-menu drop-lang"
              role="menu"
              style={{
                minWidth: '190px',
                fontSize: '1.26em',
                marginTop: '5px',
                marginRight: '18px',
              }}
            >
              {!allService.empty(user) && !allService.empty(user.name) && (
                <h6
                  className="fw-400 pr mb-0 d-md-none"
                  style={{ left: '15px', fontSize: '0.965em' }}
                >
                  {user.name.split(' ')[0]}
                  <strong>
                    {user.name.split('').length > 1
                      ? user.name.split(' ')[1]
                      : ''}
                  </strong>
                </h6>
              )}

              {!allService.empty(user) && !allService.empty(user.telephone) && (
                <span
                  className="d-block pr d-md-none"
                  style={{ fontSize: '0.665em', top: '-4px', left: '15px' }}
                >
                  {allService.chunk(user.telephone, 3, ' ')}
                </span>
              )}

              {!isAuthenticated && (
                <a onClick={() => navigation('/login')}>
                  <i
                    className="material-icons pr menu-i mr-1"
                    style={{ top: '2.9px', fontSize: '1.4em' }}
                  >
                    lock_open
                  </i>
                  &nbsp;
                  <span className="lang" keyword="my-account">
                    {t('login')}
                  </span>
                </a>
              )}

              {isAuthenticated && (
                <a onClick={() => disconnect()}>
                  <i
                    className="material-icons pr menu-i mr-1"
                    style={{ top: '3.9px', fontSize: '1.4em', padding: '1px' }}
                  >
                    power_settings_new
                  </i>
                  &nbsp;
                  <span className="lang" keyword="disconnect">
                    {t('Disconnect')}
                  </span>
                </a>
              )}
            </div>
          </div>

          <div
            onClick={() => showDownloadPopup(!downloadPopup)}
            className="fl-r mr-2"
            style={{
              display: 'inline-block',
              verticalAlign: 'bottom',
              fontSize: '0.795em',
              position: 'relative',
              top: '16px',
            }}
          >
            <a
              className="btn btn-primary option rounded-circle faq"
              role="button"
              href="#"
              style={{
                display: 'inline-block',
                padding: '1px 5px',
                paddingTop: '5px',
                fontSize: '0.985em',
                boxShadow: 'none',
                position: 'relative',
              }}
              title="Download"
            >
              <i className="material-icons">file_download</i>
            </a>
          </div>

          <div
            className="d-none d-xs-block fl-r mr-2"
            style={{
              display: 'inline-block',
              verticalAlign: 'bottom',
              fontSize: '0.795em',
              position: 'relative',
              top: '16px',
            }}
          >
            <div
              style={{
                marginRight: '5px',
                display: 'inline-block',
                verticalAlign: 'middle',
              }}
            >
              <span className="lang" keyword="fr">
                {lang}
              </span>
            </div>
            <button
              className="btn btn-primary option rounded-circle"
              type="button"
              style={{
                display: 'inline-block',
                padding: '1px 5px',
                paddingTop: '5px',
                fontSize: '0.985em',
                boxShadow: 'none',
                position: 'relative',
              }}
              data-toggle="dropdown"
              title="Langue"
            >
              <i className="material-icons">language</i>
            </button>
            <div
              className="dropdown-menu drop-lang"
              role="menu"
              style={{
                marginRight: '16px',
                marginTop: '5px',
                fontSize: '1.26em',
              }}
            >
              <a
                onClick={() => changeLanguageHandler('Fr')}
                id="fr"
                className="translate"
                data-reload
              >
                <img
                  src="/assets/img/france_96px.png"
                  style={{ width: '20px', position: 'relative', top: '-3px' }}
                />
                &nbsp;
                <span
                  className="lang"
                  keyword="french"
                  style={{ position: 'relative', top: '-2px' }}
                >
                  {t('french-lang')}
                </span>
                <br />
              </a>
              <a
                onClick={() => changeLanguageHandler('En')}
                id="en"
                className="translate"
              >
                <img
                  src="/assets/img/great_britain_96px-1.png"
                  style={{ width: '20px', position: 'relative', top: '-3px' }}
                />
                &nbsp;
                <span
                  className="lang"
                  keyword="english"
                  style={{ position: 'relative', top: '-2px' }}
                >
                  {t('english-lang')}
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div
        className="privacy-policy text-justify"
        style={{ paddingTop: '150px', paddingBottom: '60px' }}
      >
        <div
          className="row col-12 col-md-10 col-lg-8 col-xl-6 m-auto bg-white p-4 p-md-5"
          style={{ lineHeight: 2 }}
        >
          <h3 className="fw-700 mb-5 text-left" style={{ fontSize: '2.5em' }}>
            Politique de confidentialité
          </h3>

          <div className="d-block mb-4">
            <h5 className="fw-700 text-left">Introduction</h5>
            <p>
              Afin de protéger vos données personnelles lorsque vous faites vos
              achats ou recharges sur <strong>GLOTELHO PAY</strong>, nous
              élaborons cette politique de confidentialité, qui est en fait un
              contrat régissant votre utilisation de nos services.
            </p>
          </div>

          <div className="d-block mb-4">
            <h5 className="fw-700 text-left">
              Définition des données personnelles
            </h5>
            <p>
              Les données personnelles désignent toute information relative à
              une personne physique identifiée ou identifiable (personne
              concernée) ; une personne physique identifiable est une personne
              qui peut être identifiée, directement ou indirectement, notamment
              par référence à un identifiant tel qu'un nom, un numéro
              d'identification, des données de localisation. Les données
              personnelles n'incluent pas les données qui ont été anonymisées de
              manière irréversible ou agrégées de manière à ne plus nous
              permettre, que ce soit en combinaison avec d'autres informations
              ou autrement, de vous identifier. Voici une description des types
              de données personnelles que nous pouvons collecter et comment nous
              pouvons les utiliser :
            </p>
            <ol>
              <li style={{ fontWeight: 700, fontSize: '1rem' }}>
                Les données personnelles nous collectons
                <div style={{ fontWeight: 'normal', fontSize: '0.9rem' }}>
                  <p>
                    En fonction des produits et services que vous choisissez,
                    nous collectons différents types de données personnelles
                    vous concernant.
                  </p>
                  <ol
                    style={{ fontWeight: 700, fontSize: '1rem' }}
                    className="sub-list"
                  >
                    <li>
                      Les données que vous fournissez
                      <div style={{ fontWeight: 'normal', fontSize: '0.9rem' }}>
                        <p>
                          Afin d’assurer un meilleur suivi de vos transactions
                          et de vos requêtes, nous collectons les données
                          personnelles que vous fournissez lorsque vous créez un
                          compte telles que votre numéro de téléphone et votre
                          nom uniquement.
                        </p>
                      </div>
                    </li>
                    <li>
                      Les données de vos équipements terminaux
                      <div style={{ fontWeight: 'normal', fontSize: '0.9rem' }}>
                        <p>
                          Afin d’assurer un meilleur suivi de vos transactions
                          et de vos requêtes, nous collectons les données
                          personnelles que vous fournissez lorsque vous créez un
                          compte telles que votre numéro de téléphone et votre
                          nom uniquement.
                        </p>
                        <ol type="a">
                          <li className="mb-2">
                            <strong>SMS</strong> : Notre application, en
                            fonction de vos autorisations, peut accéder à la
                            lecture de vos SMS sur votre appareil, tout
                            simplement dans le but de récupérer le code dans le
                            cadre de l’authentification OTP. Si vous souhaitez
                            empêcher notre application d'accéder aux données de
                            votre téléphone, vous pouvez réinitialiser votre
                            autorisation sur votre téléphone. Après avoir obtenu
                            votre autorisation, l'accès aux SMS inclus tout
                            simplement la possibilité de : lire le contenu de
                            vos SMS, plus spécifiquement les SMS de la
                            conversation GLOTELHO, afin de récupérer automatique
                            le code reçu par SMS et faire la vérification dans
                            l’application sans que vous ne fassiez le moindre
                            effort.
                          </li>
                          <li>
                            <strong>CONTACT ET GESTIONNAIRE D’APPEL</strong> :
                            Notre application, en fonction de vos autorisations,
                            peut accéder à la lecture de vos CONTACT sur votre
                            appareil, tout simplement dans le but d’importer vos
                            contacts dans l’application, et de les utiliser lors
                            de vos recharges, sans toutefois les saisir
                            manuellement ou de les retenir. Elle peut aussi au
                            besoin, composer le numéro de notre service client
                            directement dans l’application par défaut des appels
                            de votre appareil. Si vous souhaitez empêcher notre
                            application d'accéder aux données de votre
                            téléphone, vous pouvez réinitialiser ces
                            autorisations sur votre téléphone.
                          </li>
                        </ol>
                      </div>
                    </li>
                  </ol>
                </div>
              </li>
            </ol>
          </div>

          <div className="d-block mb-4">
            <h5 className="fw-700 text-left">Vos droits</h5>
            <p>
              Nous prenons des mesures raisonnables pour nous assurer que vos
              données personnelles sont exactes, complètes et à jour. Sur la
              base de la protection de votre vie privée, vous disposez des
              droits suivants :
            </p>
            <ol>
              <li className="mb-2">
                Vous avez le droit de nous contacter pour savoir si vos données
                personnelles sont traitées ou non et, le cas échéant, accéder
                aux données et informations personnelles, y compris, mais sans
                s'y limiter, les finalités du traitement et les catégories de
                données personnelles des données concernées.
              </li>
              <li className="mb-2">
                Vous avez le droit de nous contacter pour corriger ou supprimer
                vos données personnelles inexactes. Compte tenu des finalités du
                traitement, vous êtes également libre de faire compléter des
                données personnelles incomplètes, y compris en fournissant une
                déclaration supplémentaire.
              </li>
              <li className="mb-2">
                Vous avez le droit d'obtenir de notre part l'effacement des
                données personnelles vous concernant.
              </li>
              <li className="mb-2">
                Vous avez le droit de nous contacter pour définir la restriction
                du traitement, ce qui va limiter nos autorités de traitement.
              </li>
              <li className="mb-2">
                Vous avez le droit de recevoir les données personnelles que vous
                fournissez dans un format structuré, couramment utilisé et
                lisible par la machine et de transmettre ces données à un tiers.
              </li>
              <li className="mb-2">
                Vous avez le droit de nous contacter pour faire votre opposition
                pour des motifs liés à votre situation particulière, à tout
                moment au traitement des données personnelles.
              </li>
              <li>
                Vous avez le droit de ne pas faire l'objet d'une décision basée
                uniquement sur un traitement automatisé, y compris le profilage,
                qui produit des effets juridiques vous concernant ou vous
                affecte de manière significative, de manière similaire. Lorsque
                vous avez besoin de réaliser ce droit, veuillez nous contacter
                pour offrir de l'aide.
              </li>
            </ol>
            <p>
              Pour protéger la confidentialité et la sécurité de vos données
              personnelles, nous pouvons vous demander des données pour nous
              permettre de confirmer votre identité et votre droit d'accéder à
              ces données, ainsi que de rechercher et de vous fournir les
              données personnelles que nous conservons. Il existe des cas où les
              lois ou les exigences réglementaires applicables nous permettent
              ou nous obligent à refuser de fournir ou de supprimer tout ou
              partie des données personnelles que nous conservons. Vous pouvez
              nous contacter pour exercer vos droits. Nous répondrons à votre
              demande dans les 30 jours.
            </p>
          </div>

          <div className="d-block mb-4">
            <h5 className="fw-700 text-left">Sécurité de l'information</h5>
            <p>
              Nous utilisons des mesures de sécurité techniques, administratives
              et physiques raisonnables conçues pour protéger et empêcher tout
              accès non autorisé à vos données et pour utiliser correctement les
              données que nous collectons. Par exemple, l'accès à vos données
              personnelles est strictement limité à notre responsable du
              traitement des données, notre délégué à la protection des données
              qui ont besoin d'accéder à ces données pour exécuter les tâches
              qui leur sont assignées. Nous avons mis en place un système de
              récupération pour empêcher la destruction, la perte, l'altération
              et la divulgation non autorisée de vos données causées par la
              technologie automatique. Il est important que vous preniez des
              précautions pour vous protéger contre tout accès non autorisé aux
              informations d'identification de votre compte, à votre ordinateur
              ou à d'autres appareils. « Violation de données personnelles »
              signifie une violation de la sécurité entraînant la destruction
              accidentelle ou illégale, la perte, l'altération, la divulgation
              non autorisée ou l'accès à des données personnelles transmises,
              stockées ou autrement traitées. Nous enquêterons sur toute plainte
              et informerons l'individu du résultat de l'enquête dans un délai
              raisonnable. Aussi, sachez que, malgré tous nos efforts, aucun
              système de sécurité n'est impénétrable. En cas de violation de la
              sécurité, nous vous en informerons rapidement ainsi que les
              autorités compétentes si la loi l'exige.
            </p>
          </div>

          <div className="d-block mb-4">
            <h5 className="fw-700 text-left">
              Modifications de cette déclaration de confidentialité
            </h5>
            <p>
              De temps à autre, nous pouvons mettre à jour notre politique de
              confidentialité pour refléter des pratiques de confidentialité
              nouvelles ou différentes. Nous placerons un avis à nos
              utilisateurs lorsque nous apporterons des modifications
              importantes à la politique de confidentialité. La modification de
              la politique de confidentialité est d'une grande importance pour
              garantir vos droits sur les données personnelles. Par conséquent,
              nous vous recommandons sincèrement de consulter périodiquement la
              politique de confidentialité disponible en ligne. De plus, vous
              êtes toujours libre de consulter la politique de confidentialité
              via des liens rapides chaque fois que vous avez besoin de saisir
              vos données personnelles. Simultanément, nous vous informerons de
              la modification en envoyant un avis sur votre compte. Il y aura un
              lien rapide spécial dans votre compte pour offrir le texte
              intégral de la politique de confidentialité.
            </p>
          </div>
        </div>

        <div className="modal modal-download" style={{ paddingTop: '100px' }}>
          <div
            id="modal-download"
            className="modal-content"
            style={{ overflow: 'auto', width: '45%' }}
          >
            <div>
              <i
                id="close-user-edit"
                className="icon ion-android-close close"
                onClick={() => showDownloadPopup(!downloadPopup)}
                style={{
                  color: 'inherit',
                  float: 'right',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  position: 'relative',
                  top: '0px',
                  left: '20px',
                }}
              ></i>
            </div>
            <div className="display text-left" style={{ display: 'block' }}>
              <div
                className="mt-2 text-center"
                style={{ border: 'none', padding: '0', fontSize: '1.4em' }}
              >
                <div className="row">
                  <div className="col">
                    <h4 className="fw-900 text-uppercase title1">
                      {t('download_header')}
                    </h4>
                  </div>
                </div>
                <span className="d-block mb-3" style={{ fontSize: '0.7em' }}>
                  {t('download_msg')}
                </span>
                <div className="col col-12 col-lg-8 m-auto">
                  <div className="row">
                    <div className="col p-0 pr-1">
                      <a
                        href="https://play.google.com/store/apps/details?id=cm.glotelho.glotelho_pay"
                        target="_blank"
                      >
                        <img
                          className="img-fluid"
                          src="/assets/img/google.png"
                        />
                      </a>
                    </div>
                    <div className="col p-0 pl-1">
                      <a
                        href="https://apps.apple.com/be/app/glotelho-pay/id1660530553"
                        target="_blank"
                      >
                        <img
                          className="img-fluid"
                          src="/assets/img/apple.png"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
